export function getCommentsRoutes() {
  return [
    {
      path: "/comments",
      name: "comments",
      component: () => import(/*webpackChunkName: comments-old-backend*/ "./components/CommentsOld.vue"),
    },
  ]
}
